export const COMMERCIAL_LIST_LIMIT = 1000;

export const ACTIVE_LIST_FAILED_MESSAGE = $localize`:ProductList|Failed to make Product List active@@setActiveListFailedMessage:Failed to make list active`;
